<template>
  <div class="finance-service-order-list">
    <div class="fr ac fz12 mt30">
      <div class="center order-list-item">产品信息</div>
      <div class="center order-list-item">状态</div>
      <div class="center order-list-item">日期</div>
      <div class="center order-list-item">价格</div>
      <div class="center fg">操作</div>
    </div>

    <el-divider/>

    <!--  列表-->
    <div class="order-list fz12">
      <div
          class="order-item mt20"
          v-for="(item, index) in service_list"
          :key="index"
      >
        <!--   上-->
        <div class="top fr ac">
          <p>{{ item.create_time }}</p>
          <p class="ml10">{{ item.logistics_name }}</p>
          <p class="ml10">{{ item.logistics_no }}</p>
        </div>

        <!--  中-->
        <div class="fr middle">
          <!-- 商品信息 -->
          <div class="order">
            <div class="fr order_left">
              <div class="fr ac jc order-list-item">
                <p class>【{{ item.type_name }}/{{ item.level_name }}】</p>
              </div>
              <div class="center order-list-item">
                {{ item.order_state_show }}
              </div>
              <div class="center order-list-item">
                {{ item.create_time }}
              </div>
              <div class="center order-list-item">
                ￥{{ item.order_actual_price }}
              </div>
            </div>
          </div>
          <!-- 操作 -->
          <div class="fc jc ac fg fs operating pl10 pr10 pt10 pb10">
            <p
                class="blue cursor"
                v-if="hasPermission(862)"
                @click="go(`/payment?id=${item.order_id}&type=service`)"
            >
              立即付款
            </p>
            <p
                class="mt10 cursor grey"
                @click="
                    go(`/salesservicedetail?id=${item.order_id}&type=finance`)
                  "
            >
              查看详情
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="fr jc ac mt30 mb30">
      <el-pagination
          :hide-on-single-page="true"
          :current-page.sync="page"
          layout="prev, pager, next"
          :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: "service",
  data() {
    return {
      service_list: [],
      page: 1,
      total: 0
    }
  },
  watch: {
    page(n) {
      this.getServiceOrders();
    }
  },
  mounted() {
    this.getServiceOrders();
  },
  methods: {
    getServiceOrders() {
      this.post("serviceInterfaces/v1.0/getServiceOrders", {
        page: this.page,
        contract_check_state: "1",
        pay_state: "0",
      }).then((res) => {
        this.service_list = res.data;
        this.total = res.total;
      });
    },
  }
}
</script>

<style scoped lang="scss">
.finance-service-order-list {
  background-color: #fff;

  .order-list-item {
    &:nth-of-type(1) {
      width: 260px;
    }

    width: 175px;
  }

  .order-list {
    .order-item {
      border: 1px solid #e5e5e5;

      .order-list-item {
        border-right: 1px solid #e5e5e5;

        &:nth-of-type(4) {
          border-right: none;
        }
      }

      .top {
        background-color: #f0f6ff;
        padding: 14px;
      }

      .middle {
        .order {
          .order_left {
            min-height: 80px;
            border-right: 1px solid #e5e5e5;
            border-bottom: 1px solid #e5e5e5;

            &:last-child {
              border-bottom: none;
            }

            .goods_img {
              width: 80px;
              height: 80px;
            }
          }

          .operating {
            .el-button {
              font-weight: normal;
            }

            p {
              margin-top: 10px;

              &:nth-of-type(1) {
                margin-top: 0;
              }
            }
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/page/me/finance/components/service.vue